export const ProjectsSection = () => {
    return(
        <section>
            <div className="w-full bg-gradient-to-b from-[#5e8b9b] via-[#095369] to-[#001a22] text-white py-14 px-6">
                <div className="max-w-7xl mx-auto text-center">
                    <p className="font-segoe-ui uppercase font-semibold text-xs sm:text-base tracking-widest bg-gradient-to-r from-gray-50 to-gray-500 text-center bg-clip-text text-transparent">
                        Real-world Results
                    </p>
                </div>
                <h2 className="font-segoe-ui text-3xl font-semibold mb-10 md:text-5xl text-center mt-3 sm:mt-6">
                    Arkenom Technology
                </h2>
                <p className="font-segoe-ui text-center text-xs lg:text-base text-gray-100 mt-4 mb-4 max-w-full sm:max-w-6xl mx-auto w-full">
                    Arkenom Technology provides specialized technological solutions and services to utility companies, including CRM, WFM, Call Center, and AI solutions. Backed by a strong software development and dedicated support team, it delivers AI-powered solutions tailored to meet the specific needs of its clients.
                </p>
            </div>
        </section>
    );
};